<div class="container">
  <div class="message-card">
    <ninety-alert-message type="neutral">
      <h1>Become a partner</h1>
      <p>
        You already have a Ninety account, so we'll get you set up as a partner directly.
        <br />
        Click below to chat with our team and we'll take it from there.
      </p>
      <ninety-button filled primary (click)="chatWithUs()" data-cy="become-a-partner-chat-button">
        Chat with us
      </ninety-button>
    </ninety-alert-message>
  </div>
</div>
